// KILL FEEDS:
var feeds = ["Double Kill", "Triple Kill", "Quad Kill", "Multi Kill", "Mega Kill", "Ultra Kill", "Super Kill"];

// KILL REWARD:
var tmpList = [];
module.exports.reward = function (manager, player, killed, killInfo, game) {
  tmpList.length = 0;

  // MELEE:
  if (player.weapon.melee) {
    tmpList.push("Execution", 150);
  } else {
    // SPECIAL KILL:
    if (player.weapon.kill) {
      tmpList.push(player.weapon.kill[0], player.weapon.kill[1]);

      // NO SCOPE:
    } else {
      if (player.weapon.scope && player.aimVal == 1) {
        tmpList.push("No Scope", 100);

        // NORMAL WEAPON:
      } else {
        if (!player.weapon.scope || player.aimVal == 0 && player.aimTime > 180 || player.aimDir == 1) {
          tmpList.push("", 50);

          // QUICKSCOPE:
        } else {
          tmpList.push("Quick Scope", 75);
        }
      }
    }

    // FIRST BLOOD:
    if (game.kills <= 1) {
      tmpList.push("First Blood", 25);
    }

    // SPIN SHOTS:
    var spinVal = manager.getSpin(player);
    if (!player.weapon.nSkill) {
      if (spinVal >= 360) {
        tmpList.push("360!", 150);
      }
    }

    // HEADSHOT:
    if (killInfo.headShot) {
      tmpList.push("Headshot", 50);
    }

    // LONGSHOT:
    if (!player.weapon.scope && killInfo.dst * player.weapon.range > 200) {
      tmpList.push("Longshot", 25);
    }
  }

  // FLAG CARRIER:
  if (killed.flag) {
    tmpList.push("Snatched", 50);
  }

  // CLOSE CALL:
  if (player.health <= player.maxHealth * 0.2 && player.active) {
    tmpList.push("Close Call", 20);
  }

  // COMEBACK:
  if (player.deathStreak >= 3) {
    tmpList.push("Comeback", 25);
  }

  // STREAK ENDER BONUS:
  if (killed.killStreak >= 10) {
    tmpList.push("Buzzkill", 25);
  } else {
    if (killed.killStreak >= 5) {
      tmpList.push("Buzzkill", 10);
    }
  }

  // SLIDE KILL:
  if (player.slideTimer > 0) {
    tmpList.push("Driftkill", 50);
  }

  // AIR KILL:
  if (player.airTime >= 400) {
    tmpList.push("Mid Air", 25);
  }

  // KILL FEED:
  for (var i = feeds.length - 1; i >= 0; --i) {
    if (player.streak > i) {
      tmpList.push(feeds[i], (i + 1) * 50);
      break;
    }
  }
  return tmpList.length ? tmpList : null;
};

// CALC SCORE:
module.exports.getScore = function (killData) {
  var tmpScore = 0;
  if (killData) {
    for (var i = 1; i < killData.length; i += 2) {
      tmpScore += killData[i];
    }
  }
  return tmpScore;
};